import React, { useEffect, useRef } from 'react'
import Breadcrumbs from '../components/Breadcrumbs'
import { useLocation } from 'react-router-dom';
import emailjs from '@emailjs/browser';

function Contact() {
    const location = useLocation();
    const form = useRef();
    
    // Auto-select product interest based on query param if present
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const interest = searchParams.get('interest');
        
        if (interest) {
            const select = document.getElementById('product-interest');
            const message = document.getElementById('message');
             
            if (select && message) {
                // Heuristic to select category
                const interestLower = interest.toLowerCase();
                if (interestLower.includes('printer') || interestLower.includes('entrust') || interestLower.includes('evolis') || interestLower.includes('zebra') || interestLower.includes('magicard')) {
                    select.value = "Printer";
                } else if (interestLower.includes('lanyard') || interestLower.includes('reel') || interestLower.includes('holder')) {
                    select.value = "Accessories";
                } else if (interestLower.includes('smart') || interestLower.includes('rfid') || interestLower.includes('nfc') || interestLower.includes('mifare')) {
                    select.value = "Smart Cards";
                } else if (interestLower.includes('healthcare')) {
                    select.value = "Healthcare";
                } else if (interestLower.includes('corporate')) {
                    select.value = "Corporate";
                } else if (interestLower.includes('retail') || interestLower.includes('loyalty')) {
                    select.value = "Loyalty";
                } else {
                    select.value = "Other";
                }

                message.value = `I am interested in a quote for: ${interest}. \n\nAdditional Details:`;
            }
        }
    }, [location]);

    const sendEmail = (e) => {
        e.preventDefault();

        // NOTE: You must replace these placeholders with your actual EmailJS credentials.
        // Sign up at https://www.emailjs.com/
        // 1. Create a Service (e.g., Gmail service) -> Get Service ID
        // 2. Create an Email Template -> Get Template ID
        //    Ensure template variables match form names: {{name}}, {{email}}, {{phone}}, 
        //    {{company}}, {{product_interest}}, {{quantity}}, {{message}}
        // 3. Account > API Keys -> Get Public Key
        
        const serviceId = 'service_taa5loa';
        const templateId = 'template_qpzvtiu';
        const publicKey = 'ZXwl4fTP5KsSfrL01';

        emailjs.sendForm(serviceId, templateId, form.current, publicKey)
            .then((result) => {
                console.log(result.text);
                alert("Thank you! Your quote request has been submitted successfully to our team.");
                e.target.reset(); // Clear the form
            }, (error) => {
                console.error(error.text);
                alert("Failed to send the request. Please try again later or contact us directly via phone.");
            });
    };

    return (
        <div>
            <Breadcrumbs pageTitle="Request a Quote" title="Contact Us" />
            <main>

                {/* contact-us-start */}
                <section className="contact-us__area section-space overflow-hidden">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-xl-5">
                                <div className="contact-us__widget mb-30 wow fadeInRight animated" data-wow-delay=".3s">
                                    <h3 className="contact-us__widget-title mb-10">Get Your Custom Quote</h3>
                                    <p className="mb-40 mb-sm-25 mb-xs-20 fadeInLeft animated" data-wow-delay=".5s">
                                        Looking for ID card printers, bulk smart cards, or custom accessories? 
                                        Fill out the form and our team will get back to you with a competitive quote.
                                    </p>

                                    <div className="contact-us__widget-list">
                                        <div className="contact-us__widget-list-item">
                                            <div className="icon">
                                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M13.388 4.82261C14.3232 5.00472 15.1827 5.46123 15.8565 6.1337C16.5302 6.80617 16.9876 7.66402 17.1701 8.59743M13.388 1C15.331 1.21544 17.1429 2.08388 18.5261 3.46272C19.9093 4.84157 20.7817 6.64887 21 8.58788M20.0425 16.214V19.0809C20.0436 19.3471 19.989 19.6105 19.8821 19.8544C19.7753 20.0983 19.6186 20.3172 19.4221 20.4971C19.2256 20.677 18.9937 20.814 18.7411 20.8993C18.4885 20.9845 18.2208 21.0162 17.9552 20.9922C15.0089 20.6727 12.1787 19.6678 9.69214 18.0584C7.37869 16.5911 5.4173 14.6335 3.94724 12.3245C2.32908 9.83138 1.32206 6.99289 1.00777 4.03897C0.983845 3.7747 1.01531 3.50836 1.10017 3.25689C1.18503 3.00543 1.32141 2.77435 1.50065 2.57838C1.67989 2.3824 1.89804 2.22582 2.14123 2.11861C2.38442 2.0114 2.64731 1.9559 2.91316 1.95565H5.78561C6.25028 1.95109 6.70076 2.11532 7.05309 2.41774C7.40541 2.72016 7.63554 3.14013 7.70057 3.59937C7.82181 4.51686 8.04665 5.41772 8.37081 6.28476C8.49963 6.62681 8.52751 6.99855 8.45115 7.35593C8.37478 7.71331 8.19737 8.04135 7.93994 8.30118L6.72394 9.51486C8.08697 11.9074 10.0717 13.8883 12.4688 15.2488L13.6848 14.0351C13.9452 13.7782 14.2738 13.6011 14.6319 13.5249C14.99 13.4486 15.3624 13.4765 15.7051 13.6051C16.5738 13.9286 17.4764 14.153 18.3956 14.274C18.8608 14.3395 19.2855 14.5733 19.5892 14.931C19.8928 15.2887 20.0542 15.7453 20.0425 16.214Z" stroke="#ececec" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                            <div className="text">
                                                <span>Phone Number</span>
                                                <a href="tel:+917736744500">+91 7736744500</a>
                                            </div>
                                        </div>
                                        <div className="contact-us__widget-list-item mt-40 mb-40">
                                            <div className="icon">
                                                <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3 1H19C20.1 1 21 1.91406 21 3.03125V15.2188C21 16.3359 20.1 17.25 19 17.25H3C1.9 17.25 1 16.3359 1 15.2188V3.03125C1 1.91406 1.9 1 3 1Z" stroke="#ececec" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M21 3.03125L11 10.1406L1 3.03125" stroke="#ececec" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                            <div className="text">
                                                <span>Email</span>
                                                <a href="mailto:sales@nexusidsystems.com">sales@nexusidsystems.com</a>
                                            </div>
                                        </div>
                                        <div className="contact-us__widget-list-item">
                                            <div className="large-hight">
                                                <svg width="22" height="27" viewBox="0 0 22 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M21 11.2273C21 19.1818 11 26 11 26C11 26 1 19.1818 1 11.2273C1 8.51483 2.05357 5.91348 3.92893 3.9955C5.8043 2.07751 8.34784 1 11 1C13.6522 1 16.1957 2.07751 18.0711 3.9955C19.9464 5.91348 21 8.51483 21 11.2273Z" stroke="#ececec" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M10.9993 14.6365C12.8403 14.6365 14.3327 13.1102 14.3327 11.2275C14.3327 9.34466 12.8403 7.81836 10.9993 7.81836C9.1584 7.81836 7.66602 9.34466 7.66602 11.2275C7.66602 13.1102 9.1584 14.6365 10.9993 14.6365Z" stroke="#ececec" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                            <div className="text">
                                                <a href="https://maps.google.com/?q=Ernakulam,+Kerala,+India" target="_blank" rel="noreferrer">Ernakulam, Kerala, India</a>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="col-xl-7">
                                <div className="contact-us__form-wrapper mb-30 mb-xs-25">
                                    <h3 className="section__title mb-10 wow fadeInLeft animated" data-wow-delay=".3s">Request a Quote</h3>
                                    <p className="mb-40 mb-sm-25 mb-xs-20 wow fadeInLeft animated" data-wow-delay=".5s">
                                        Please provide details about your requirements so we can assist you better.
                                    </p>


                                    <form className="contact-us__form" ref={form} onSubmit={sendEmail}>
                                        <div className="row wow fadeInLeft animated" data-wow-delay=".9s">
                                            <div className="col-sm-6">
                                                <div className="contact-us__input">
                                                    <input name="name" id="name" type="text" placeholder="Your Name" required />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="contact-us__input">
                                                    <input name="email" id="email" type="email" placeholder="Email Address" required />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="contact-us__input">
                                                    <input name="phone" id="phone" type="text" placeholder="Phone Number" required />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="contact-us__input">
                                                    <input name="company" id="company" type="text" placeholder="Company / Organization" />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="contact-us__select">
                                                    <select name="product_interest" id="product-interest" style={{width: '100%', height: '55px', border: '1px solid #ECECEC', borderRadius: '5px', padding: '0 20px', color: '#6A7280', marginBottom: '20px'}}>
                                                        <option value="">Product Interest...</option>
                                                        <option value="Printer">ID Card Printer (Entrust/Evolis)</option>
                                                        <option value="Bulk Cards">Bulk Cards (PVC/RFID/Metal)</option>
                                                        <option value="Accessories">Accessories (Lanyards/Holders)</option>
                                                        <option value="Smart Cards">Smart Cards & Technology</option>
                                                        <option value="Healthcare">Healthcare Solution</option>
                                                        <option value="Corporate">Corporate Solution</option>
                                                        <option value="Loyalty">Loyalty/Retail Solution</option>
                                                        <option value="Other">Other</option>
                                                    </select>
                                                </div>
                                            </div>
                                             <div className="col-sm-6">
                                                <div className="contact-us__input">
                                                    <input name="quantity" id="quantity" type="text" placeholder="Estimated Quantity" />
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="contact-us__textarea ">
                                                    <textarea name="message" id="message" cols="30" rows="5" placeholder="Additional Details / Message"></textarea>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <button type="submit" className="rr-btn mt-30">Submit Quote Request</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* contact-us-end */}

            </main>
            <div className="map">
                 <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d251482.38575971706!2d76.13612117502758!3d9.982680916297314!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b080d514abec6bf%3A0xbd582caa5844192!2sErnakulam%2C%20Kerala!5e0!3m2!1sen!2sin!4v1716300000000!5m2!1sen!2sin" 
                    width="100%" 
                    height="450" 
                    style={{ border: '0' }} 
                    allowFullScreen="" 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Nexus ID Systems Location">
                </iframe>
            </div>
        </div>
    )
}

export default Contact